'use strict'; // Customized for this use-case

var _slicedToArray = require("C:\\Code\\fiducius-app\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/slicedToArray");

var isObject = function isObject(x) {
  return typeof x === 'object' && x !== null && !(x instanceof RegExp) && !(x instanceof Error) && !(x instanceof Date);
};

module.exports = function mapObj(object, fn, options, seen) {
  options = Object.assign({
    deep: false,
    target: {}
  }, options);
  seen = seen || new WeakMap();

  if (seen.has(object)) {
    return seen.get(object);
  }

  seen.set(object, options.target);
  var _options = options,
      target = _options.target;
  delete options.target;

  var mapArray = function mapArray(array) {
    return array.map(function (x) {
      return isObject(x) ? mapObj(x, fn, options, seen) : x;
    });
  };

  if (Array.isArray(object)) {
    return mapArray(object);
  } /// TODO: Use `Object.entries()` when targeting Node.js 8


  var _arr = Object.keys(object);

  for (var _i = 0; _i < _arr.length; _i++) {
    var key = _arr[_i];
    var value = object[key];

    var _fn = fn(key, value, object),
        _fn2 = _slicedToArray(_fn, 2),
        newKey = _fn2[0],
        newValue = _fn2[1];

    if (options.deep && isObject(newValue)) {
      newValue = Array.isArray(newValue) ? mapArray(newValue) : mapObj(newValue, fn, options, seen);
    }

    target[newKey] = newValue;
  }

  return target;
};